<section class="last-section" id="contactUs">
    <div class="flex-container">
        <div class="flex-slide singapore">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="assets/images/Merlion-at-the-Singapore-River.jpg"
                class="lasyItem loadVideoPoster" alt="Singapore Location" loading="lazy" title="Merlion-at-the-Singapore-River">
  
            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>SINGAPORE<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        68 CIRCULAR ROAD, #02-01,
                        <br>Singapore, 049422
                    </p>
                </div>
            </div>
        </div>
        <div class="flex-slide singapore">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/miltiadis-fragkidis-5ULk8EgE8tg-unsplash.jpg3.1%20(1).jpg?alt=media&token=d5e08080-3460-4ff1-87bd-e6940758749e"
                class="lasyItem loadVideoPoster" alt="USA Location" loading="lazy" title="miltiadis-fragkidis-5ULk8EgE8tg-unsplash">
  
            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>USA<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        17350 State Hwy 249, Ste 220 #22793, Houston, Texas 77064 USA
                    </p>
                </div>
            </div>
        </div>
        <div class="flex-slide hyderabad">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/hyderabad%20(1).jpg?alt=media&token=35db9a52-1e12-4844-9834-6f6b633789a1"
                class="lasyItem loadVideoPoster" alt="Hyderabad Location" loading="lazy">
  
            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>HYDERABAD<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        403, Ashirwad Nilayam,
                        <br>Camelot Layout,
                        <br> Hyderabad 500084
                    </p>
  
                </div>
            </div>
        </div>
        <div class="flex-slide jaipur">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/jpeg-optimizer_jaipur%20(1).jpg?alt=media&token=52594c58-d674-4056-b26a-fb79f9c2336c"
                class="lasyItem loadVideoPoster" alt=" Jaipur Location" loading="lazy">
  
            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>JAIPUR<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        7, Shanti Nagar Rd, Shanthi Nagar,
                        <br>Mansarovar,
                        <br>Jaipur, Rajasthan 302020
                    </p>
                </div>
            </div>
        </div>
  
    </div>
</section>